<template>
	<dialog-form
		:value="value"
		@input="$emit('input', $event)"
		:title="$localize('DeleteApiKey.title')"
		@commit="save"
		:allow-continue="false"
		action="delete"
	>
		{{ $localize('DeleteApiKey.message') }}
	</dialog-form>
</template>

<script>
import DialogForm from '@/shared/components/DialogForm'

import sendCommand from '@/services/sendCommand'
import { isGuid } from '@/services/validation'

export default {
	components: { DialogForm },
	props: {
		value: Boolean,
		apiKeyId: {
			validator: isGuid,
			required: true,
		},
	},

	methods: {
		async save(callback) {
			const result = await sendCommand('DeleteApiKey', { apiKeyId: this.apiKeyId })

			if (result.success) {
				this.$emit('saved')
			}
			callback({ success: result.success })
		},
	},
}
</script>
